import { Box, Flex, Heading } from '@radix-ui/themes';

function Engelbrecht() {
    return (
        <>
            <Box p="6">
                <Heading as="h3" size="8" weight="bold" mb="2" style={{ color: '#209EB4' }}>
                    ECO-POSTERS
                </Heading>
                <Heading as="h4" size="8" weight="regular" mt="6" mb="6">
                    Billboard designs (Eco-Posters) for upcoming and current Gold Country Casino Events. Featured on select print style
                    billboards in northern California.
                </Heading>
                <Flex direction={{ initial: 'column', xl: 'row' }} gap="4">
                    <Box style={{ aspectRatio: '440/500', maxHeight: 470, maxWidth: 414 }}>
                        <img
                            src={'/images/GCC_Billboard.png'}
                            alt="Eco Poster 1"
                            loading="lazy"
                            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                        />
                    </Box>
                    <Flex direction="column" gap="4" flexGrow="1" maxHeight={{ xl: '500px' }}>
                        <Flex direction={{ initial: 'column', xl: 'row' }} gap="4" flexGrow="1">
                            <Box style={{ aspectRatio: '552/257', flex: 1, minWidth: 400, maxWidth: 500 }}>
                                <img
                                    src={'/images/GCC_Ranch_Hands_Cowboylesque.png'}
                                    alt="Eco Poster 2"
                                    loading="lazy"
                                    style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                                />
                            </Box>
                            <Box style={{ aspectRatio: '552/257', flex: 1, minWidth: 400, maxWidth: 500 }}>
                                <img
                                    src={'/images/GCC_Game_Tyme.png'}
                                    alt="Eco Poster 3"
                                    loading="lazy"
                                    style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                                />
                            </Box>
                        </Flex>
                        <Flex direction={{ initial: 'column', xl: 'row' }} gap="4" flexGrow="1">
                            <Box style={{ aspectRatio: '552/257', flex: 1, minWidth: 400, maxWidth: 500 }}>
                                <img
                                    src={'/images/GCC_LeAnn_Rimes.png'}
                                    alt="Eco Poster 4"
                                    loading="lazy"
                                    style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                                />
                            </Box>
                            <Box style={{ aspectRatio: '552/257', flex: 1, minWidth: 400, maxWidth: 500 }}>
                                <img
                                    src={'/images/GCC_Spazmatics.png'}
                                    alt="Eco Poster 5"
                                    loading="lazy"
                                    style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                                />
                            </Box>
                        </Flex>
                    </Flex>
                </Flex>
            </Box>
            <Box p="6">
                <Heading as="h3" size="8" weight="bold" mb="2" style={{ color: '#209EB4' }}>
                    DIGITAL BILLBOARDS
                </Heading>
                <Heading as="h4" size="8" weight="regular" mt="6" mb="6">
                    Digital Billboard designs. Similarly to Eco-Posters, features Gold Country Casino event advertising across Northern
                    California.
                </Heading>
                <Flex direction={{ initial: 'column', xl: 'row' }} gap="4">
                    <Flex direction="column" gap="4" maxWidth="599px">
                        <Box style={{ aspectRatio: '599/300', maxHeight: 300 }}>
                            <img src={'/images/GCC_Niko_Moon_Oroville.png'} alt="Niko Moon Oroville" loading="lazy" />
                        </Box>
                        <Heading as="h4" size="8" weight="regular" align="center">
                            OROVILLE
                        </Heading>
                    </Flex>
                    <Flex direction="column" gap="4" maxWidth="900px">
                        <Box style={{ aspectRatio: '1021/300', maxHeight: 300 }}>
                            <img src={'/images/GCC_Niko_Moon_Roseville.png'} alt="Niko Moon Roseville" loading="lazy" />
                        </Box>
                        <Heading as="h4" size="8" weight="regular" align="center">
                            ROSEVILLE
                        </Heading>
                    </Flex>
                </Flex>
                <Flex direction={{ initial: 'column', xl: 'row' }} gap="4" mt="4">
                    <Flex direction="column" gap="4" maxWidth="805px">
                        <Box style={{ aspectRatio: '1050/300', maxHeight: 300 }}>
                            <img src={'/images/GCC_Niko_Moon_L_Sac.png'} alt="Niko Moon L Sacramento" loading="lazy" />
                        </Box>
                        <Heading as="h4" size="8" weight="regular" align="center">
                            L-SAC
                        </Heading>
                    </Flex>
                    <Flex direction="column" gap="4" maxWidth="805px">
                        <Box style={{ aspectRatio: '1050/300', maxHeight: 300 }}>
                            <img src={'/images/GCC_Niko_Moon_O_Sac.png'} alt="Niko Moon O Sacramento" loading="lazy" />
                        </Box>
                        <Heading as="h4" size="8" weight="regular" align="center">
                            O-SAC
                        </Heading>
                    </Flex>
                </Flex>
            </Box>
            <Box p="6">
                <Heading as="h3" size="8" weight="bold" mb="2" style={{ color: '#209EB4' }}>
                    SOCIAL MEDIA
                </Heading>
                <Flex direction={{ initial: 'column', xl: 'row' }} gap="4" wrap="nowrap" mt="4">
                    <Box style={{ aspectRatio: '700/700', maxHeight: 700, maxWidth: 700, overflow: 'hidden' }}>
                        <img
                            src={'/images/GCC_new_clairvaux_wine.png'}
                            alt="Stamp Card 04"
                            style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                        />
                    </Box>
                    <Flex wrap="wrap" justify="between" gap="4" pl={{ xl: '6' }} maxWidth="900px">
                        <Heading as="h4" size="8" weight="regular">
                            Social media posts for Instagram. Featured advertised events, performers, sections of the casino, and cuisine on
                            a daily basis.
                        </Heading>
                        <Box style={{ aspectRatio: '500/500', minWidth: 400, maxWidth: '48%', overflow: 'hidden' }}>
                            <img
                                src={'/images/GCC_Safire_Easter_2.png'}
                                alt="Stamp Card 03"
                                style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                            />
                        </Box>
                        <Box style={{ aspectRatio: '500/500', minWidth: 400, maxWidth: '48%', overflow: 'hidden' }}>
                            <img
                                src={'/images/GCC_Safire_Easter_1.png'}
                                alt="Stamp Card 02"
                                style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                            />
                        </Box>
                    </Flex>
                </Flex>
            </Box>
            <Box p="6">
                <Heading as="h3" size="8" weight="bold" mb="2" style={{ color: '#209EB4' }}>
                    MONTHLY MAILER
                </Heading>
                <Flex direction={{ initial: 'column', xl: 'row' }} gap="6" wrap="nowrap" mt="4">
                    <Flex wrap="wrap" gap="4" maxWidth="927px" minWidth="400px">
                        <Flex direction="column" gap="4">
                            <img
                                src={'/images/GCC_Mailer_1.png'}
                                alt="Mailer 1"
                                style={{ objectFit: 'contain', maxWidth: '100%', maxHeight: '100%', flexShrink: 1 }}
                            />
                            <Heading as="h4" size="8" weight="regular" style={{ flexShrink: 0 }}>
                                A monthly mailer collaborative project for Gold Country Casino Resort. Of the several pages designed by our
                                team, each designer developed their own cover around the month's theme. From that point the client (GCCR)
                                chose their preferred design or a combination of elements from each. The calendar page, which depicted the
                                monthly events and entertainment in a calendar format, and the backside ad were often my responsibilities as
                                well.
                            </Heading>
                        </Flex>
                    </Flex>
                    <Flex minWidth="400px">
                        <img
                            src={'/images/GCC_Mailer_2.png'}
                            alt="Mailer 1"
                            style={{ objectFit: 'contain', maxWidth: '100%', maxHeight: '100%', flexShrink: 1 }}
                        />
                    </Flex>
                </Flex>
            </Box>
            <Box p="6">
                <Heading as="h3" size="8" weight="bold" mb="2" style={{ color: '#209EB4' }}>
                    POSTERS
                </Heading>
                <Flex direction={{ initial: 'column', xl: 'row' }} gap="4" wrap="nowrap" mt="4">
                    <Flex minWidth="270px">
                        <img
                            src={'/images/GCC_Jeff_Foxworthy.png'}
                            alt="Jeff Foxworthy Poster"
                            style={{ objectFit: 'contain', maxWidth: '100%', maxHeight: '100%', flexShrink: 1 }}
                        />
                    </Flex>
                    <Flex minWidth="270px">
                        <img
                            src={'/images/GCC_Ranch_Hands_Cowboylesque_Poster.png'}
                            alt="Ranch Hands Cowboylesque Poster"
                            style={{ objectFit: 'contain', maxWidth: '100%', maxHeight: '100%', flexShrink: 1 }}
                        />
                    </Flex>
                    <Flex minWidth="270px">
                        <img
                            src={'/images/GCC_100k_Point_Series_Tournament_Poster.png'}
                            alt="100K Point Series Tournament Poster"
                            style={{ objectFit: 'contain', maxWidth: '100%', maxHeight: '100%', flexShrink: 1 }}
                        />
                    </Flex>
                    <Flex minWidth="270px">
                        <img
                            src={'/images/GCC_LeAnn_Rimes_Poster.png'}
                            alt="LeAnn Rimes Poster"
                            style={{ objectFit: 'contain', maxWidth: '100%', maxHeight: '100%', flexShrink: 1 }}
                        />
                    </Flex>
                    <Flex minWidth="270px">
                        <img
                            src={'/images/GCC_Noodle_Bar_Poster.png'}
                            alt="Noodle Bar Poster"
                            style={{ objectFit: 'contain', maxWidth: '100%', maxHeight: '100%', flexShrink: 1 }}
                        />
                    </Flex>
                </Flex>
                <Heading as="h4" size="8" weight="regular" mt="4">
                    Poster designs for Gold Country Casino Resort depicting current events, performers, or other happenings the casino was
                    currently promoting. Displayed on the casino floor preceding depicted events.
                </Heading>
            </Box>
            <Box p="6">
                <Heading as="h3" size="8" weight="bold" mb="2" style={{ color: '#209EB4' }}>
                    APPEAL DEMOCRATE & OROVILLE CHAMBER
                </Heading>
                <Flex direction={{ initial: 'column', xl: 'row' }} gap="4" wrap="nowrap" mt="4">
                    <Flex wrap="wrap" gap="4" maxWidth="500px" minWidth="400px">
                        <Flex direction="column" gap="4">
                            <Heading as="h4" size="8" weight="regular" style={{ flexShrink: 0 }}>
                                Gold Country Casino ad for newspaper "Appeal Democrat" featuring the Casinos upcoming events and
                                performances.
                            </Heading>
                            <img
                                src={'/images/GCC_Appeal_Democrate.png'}
                                alt="Appeal Democrate"
                                style={{ objectFit: 'contain', maxWidth: '100%', maxHeight: '100%', flexShrink: 1 }}
                            />
                        </Flex>
                    </Flex>
                    <Flex wrap="wrap" gap="4" maxWidth="927px" minWidth="400px">
                        <Flex direction="column" gap="4">
                            <img
                                src={'/images/GCC_Oroville_Chamber.png'}
                                alt="Oroville Chamber"
                                style={{ objectFit: 'contain', maxWidth: '100%', maxHeight: '100%', flexShrink: 1 }}
                            />
                            <Heading as="h4" size="8" weight="regular" style={{ flexShrink: 0 }}>
                                Double sided Ad for the Oroville Chamber, includes the Casinos upcoming events and performances
                            </Heading>
                        </Flex>
                    </Flex>
                </Flex>
            </Box>
        </>
    );
}

export default Engelbrecht;
